<template>
    <div class="flex-center">
        <div v-if="presenting">
            <a v-if="meta.link" :href="meta.link">
                {{ value }}
            </a>
            <span v-else>{{ value }}</span>
        </div>
        <template v-else>
            <div class="flex-grow max-w-6xl">
                <div class="text-blue-700 font-semibold uppercase tracking-widest mb-4">{{ label }}</div>
                <div class="w-full">
                    <div v-for="option in options"><label><input type="checkbox" v-model="input" :value="option.value"> {{option.text}}</label></div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {BaseField} from 'superv-js'

export default {
    name: 'SvBelongsToManyField',
    mixins: [BaseField],

    data() {
        return {
            options: [],
            values: [],
            input: this.value || []
        }
    },

    created() {
        this.fetchValues()

        if (this.meta.listen_event) {
            this.$events.listen(this.meta.listen_event, query => {
                this.fetchOptions(query)
                this.values = []

                this.$emit('input', [])
            })
        } else {
            this.fetchOptions()
        }
    },
    methods: {
        commit() {
            this.values = this.values.sort(sortByName)
            this.options = this.options.sort(sortByName)
            this.$emit('input', this.values.map(option => option.value))
        },
        selectAll() {
            this.values = [...this.values, ...this.options]
            this.options = []
            this.commit()
            // this.$emit('input', this.values.map(option => option.value))
        },
        removeAll() {
            this.options = [...this.values, ...this.options]
            this.values = []
            this.commit()
            // this.$emit('input', this.values.map(option => option.value))
        },
        moveToValues(option) {
            const index = this.options.indexOf(option)
            if (index > -1) {
                this.options.splice(index, 1)
                this.values.push(option)

                this.commit()
            }
        },
        moveToOptions(option) {
            const index = this.values.indexOf(option)
            if (index > -1) {
                this.values.splice(index, 1)
                this.options.push(option)

                this.commit()
            }
        },
        async fetchOptions(query = {}) {
            if (!this.meta.options) {
                return
            }
            const resp = await this.$api.post(this.meta.options, { query })
            if (resp.fail) {
                return this.$notifyError(resp)
            }
            this.options = resp.$data
            this.commit()
        },
        async fetchValues(query = {}) {
            if (!this.meta.values) {
                return
            }
            const resp = await this.$api.post(this.meta.values, { query })
            if (resp.fail) {
                return this.$notifyError(resp)
            }
            this.values = resp.$data || []
            this.commit()
        },
    },
}

const sortByName = function (a, b) {
    var nameA = a.text
    var nameB = b.text
    return nameA.localeCompare(nameB)
    console.log(nameA, nameB)
    if (nameA < nameB) {
        return -1
    }
    if (nameA > nameB) {
        return 1
    }

    return 0
}
</script>
